// Amazon never sends a chosen shipping service for Prime or Ship+ orders, so on
// these two templates the "Std UK Dom" rows are the fallback we ship against
// rather than a buyer selection. Sellers can't tell that from the form alone.
// Keep in sync with POSTAGE_RULES_* in the API's variationDefaultsService.
const DEFAULTED_SHIPPING_TEMPLATES = ['Nationwide Prime', 'FBM SHIP+'];

// Template names above only ever map to Std UK Dom_1/_2/_3, but the form lists
// every Amazon postage, so match on the name too and stay correct if more are added.
const STANDARD_DOMESTIC_PREFIX = 'std uk dom';

export const AMAZON_DEFAULT_POSTAGE_HINT =
  'This is the default postage used when Amazon classifies a Prime or Ship+ order ' +
  'as standard delivery. Otherwise, we use the postage selected by Amazon.';

export function isAmazonDefaultPostage(shippingTemplateName, postageName) {
  return (
    DEFAULTED_SHIPPING_TEMPLATES.includes(shippingTemplateName) &&
    String(postageName || '').toLowerCase().startsWith(STANDARD_DOMESTIC_PREFIX)
  );
}
